import React, {useEffect} from 'react';
import {useTranslation} from "react-i18next";
import {GetOffices} from "../../../api/offices/GetOffices";
import InfoChip from "../../InfoChip";
import FormRepeater from "../../form/FormRepeater";
import Amount from '../../Amount';

const Finalize = ({formData, setFormData}) => {

    const { t } = useTranslation();

    useEffect(() => {
        const fetchOffices = async () => {
            try {
                const { data : offices } = await GetOffices({limit: -1});
                const selectedOffice = offices.find(office => office.id === formData.office_id);
                if (selectedOffice) {
                    // Update formData when cards or office_id changes
                    setFormData(prevData => ({
                        ...prevData,
                        office_name: selectedOffice.name
                    }));
                }
            } catch (err) {
                console.log(err);
            }
        };
        if(!formData.office_name){
            fetchOffices();
        }
    }, []);

    useEffect(() => {

        const totalCollected = formData.payments.reduce((acc, payment) => acc + (Number(payment.amount) || 0), 0);

        setFormData(prevData => ({
            ...prevData,
            total_collected: totalCollected
        }));
    }, [formData.payments]);

    return (
        <div className="step">
            <div className="container container-md">

                <div className="mb-2">
                    <p style={{color: "var(--color-primary)"}}><strong>{t("Office Name:")}</strong> {formData.office_name || t("Loading office...")}
                    </p>
                    {formData.client_company_name &&
                        <p className="mb-2" style={{color: "var(--color-primary)"}}><strong>{t("Client Company Name:")}</strong> {formData.client_company_name}
                        </p>}
                </div>

                <div className="mb-1">
                    <h5 className="mb-0">{t("Card Details")}</h5>
                    <hr className="size-3"/>
                    <FormRepeater
                        columns={[
                            t("Start Proxy Number"),
                            t("End Proxy Number"),
                            t("Card Type"),
                            t("Load Amount"),
                        ]}
                        maxRows={1}
                        addRowText={t("Add Card")}
                        RenderComponent={({rowData}) => (
                            <>
                                <td>{rowData.start_processor_reference}</td>
                                <td>{rowData.end_processor_reference}</td>
                                <td>{rowData.card_type}</td>
                                <td><Amount amount={rowData.load_amount} /></td>
                            </>
                        )}
                        onRowChange={card => setFormData(prevData => ({
                            ...prevData,
                            card
                        }))}
                        rowData={formData.card}
                        formData={formData}
                    />
                </div>

                <div className="mb-1">
                    <h5 className="mb-0">{t("Payment Details")}</h5>
                    <hr className="size-3"/>
                    <FormRepeater
                        columns={[
                            t("Payment Name"),
                            t("Confirmation Code"),
                            t("Amount"),
                        ]}
                        RenderComponent={({rowData}) => (
                            <>
                                <td>{rowData?.payment_type?.label}</td>
                                <td>{rowData?.confirmation_code}</td>
                                <td><Amount amount={rowData?.amount} /></td>
                            </>
                        )}
                        rowData={formData.payments}
                        hideAddRow
                    />
                </div>

                <div className="text-right">
                    <InfoChip value={Number(formData.quantity)} description={t('Cards')} className="mr-3"/>
                    <InfoChip value={<Amount amount={formData.total_cost} />} description={t('Total Amount')}/>
                </div>

            </div>
        </div>
    );
};

export default Finalize;
